// Mirrors canReceiveNotifications in p3kln-bo-service: superadmin always;
// verifikator and BP3MI only within Direktorat Vokasi.
export const canReceiveNotifications = (user) => {
  const position = (user?.position || "").trim().toLowerCase();
  if (position === "superadmin") return true;
  return (
    ["verifikator", "bp3mi"].includes(position) &&
    user?.directorate === "Direktorat Vokasi"
  );
};
